import { createTheme } from "@mui/material/styles";
import baseTheme from "./baseTheme";

// Partner Paper — warm ledger: deep teal + terracotta on cream (no blue)
const partnerPaperTheme = createTheme(baseTheme, {
  palette: {
    mode: "light",
    primary: { main: "#0d9488", light: "#14b8a6", dark: "#0f766e" },
    secondary: { main: "#c2410c", light: "#ea580c", dark: "#9a3412" },
    background: { default: "#f5f2eb", paper: "#fffef9" },
    text: {
      primary: "#1c1917",
      secondary: "#57534e",
    },
    divider: "rgba(28, 25, 23, 0.08)",
    sectionHeading: "#0f766e",
  },
  typography: {
    fontFamily: '"DM Sans", "Segoe UI", system-ui, -apple-system, sans-serif',
    h3: { fontWeight: 700, letterSpacing: -0.02 },
    h5: { fontWeight: 700, letterSpacing: -0.01 },
    h6: { fontWeight: 600 },
    body2: { color: "#57534e" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: "0 10px 28px rgba(28, 25, 23, 0.07), 0 1px 0 rgba(255, 255, 255, 0.9)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          textTransform: "none",
          fontWeight: 600,
          paddingInline: 18,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
  },
});

export default partnerPaperTheme;
